import React, { useState } from 'react';
import VisaInfo from './VisaInfoBD.jsx';
import TravelInsurance from './TravelInsurance.jsx'; 
import './VisaInsurance.css'

const VisaInsurance = () => {
  const [activeTab, setActiveTab] = useState('visa');

  return (
    <div className="privacy-and-terms" style={{marginBottom:'80px'}}>
      <div className="privacy-and-terms-header">
        <div className="privacy-and-terms-tabs" >
          <button
            className={`privacy-tab ${activeTab === 'visa' ? 'active' : ''}`}
            onClick={() => setActiveTab('visa')}
          >
            Visa
          </button>
          
          <button
            className={`privacy-tab ${activeTab === 'travel' ? 'active' : ''}`}
            onClick={() => setActiveTab('travel')}
          >
            Insurance
          </button>
        </div>
      </div>

      <div className="privacy-tab-content">
        {activeTab === 'visa' && <VisaInfo />} 
        {activeTab === 'travel' && <TravelInsurance />} 
      </div>
    </div>
  );
};

export default VisaInsurance;
